import { Navigate } from "react-router-dom";
import { DashboardLayout } from "../pages/dashboard/layout/DashboardLayout";
import { LazyRoute } from "../utils/helpers";
import { IModuleRouter } from "./index";

export const AjosquadDashRouter: IModuleRouter = {
  key: "dashboard",
  guard: (loggedIn) => loggedIn,
  layout: DashboardLayout,
  routes: [
    {
      index: true,
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "/",
      element: <Navigate to="/dashboard" />,
    },
    LazyRoute(
      {
        path: "/dashboard",
      },
      () => import("../pages/dashboard/Dashboard"),
    ),
    LazyRoute(
      {
        path: "/squad",
      },
      () => import("../pages/dashboard/Squad"),
    ),
    LazyRoute(
      {
        path: "/squad/connect-gocardless",
      },
      () => import("../pages/dashboard/ConnectGoCardless"),
    ),
    LazyRoute(
      {
        path: "/payment",
      },
      () => import("../pages/dashboard/Payment"),
    ),
    LazyRoute(
      {
        path: "/payout",
      },
      () => import("../pages/dashboard/Payout"),
    ),
    LazyRoute(
      {
        path: "/help",
      },
      () => import("../pages/dashboard/HelpDesk"),
    ),
    LazyRoute(
      {
        path: "/referral",
      },
      () => import("../pages/dashboard/Referral/Referral"),
    ),
    LazyRoute(
      {
        path: "/account",
      },
      () => import("../pages/dashboard/Account/Account"),
    ),
    LazyRoute(
      {
        path: "/notification",
      },
      () => import("../pages/dashboard/Notifications"),
    ),
    {
      path: "*",
      element: <Navigate to="/dashboard" />,
    },
  ],
};

export const AjohomeDashRouter: IModuleRouter = {
  key: "dashboard",
  guard: (loggedIn) => loggedIn,
  layout: DashboardLayout,
  routes: [
    {
      index: true,
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "/",
      element: <Navigate to="/dashboard" />,
    },
    LazyRoute(
      {
        path: "/dashboard",
      },
      () => import("../pages/ajohomeDashboard/Dashboard"),
    ),
    LazyRoute(
      {
        path: "/pod",
      },
      () => import("../pages/ajohomeDashboard/Pod"),
    ),
    LazyRoute(
      {
        path: "/pods/connect-gocardless",
      },
      () => import("../pages/ajohomeDashboard/ConnectGoCardless"),
    ),
    LazyRoute(
      {
        path: "/payment",
      },
      () => import("../pages/ajohomeDashboard/Payment"),
    ),
    LazyRoute(
      {
        path: "/portfolio",
      },
      () => import("../pages/ajohomeDashboard/Gallery/Index"),
    ),
    LazyRoute(
      {
        path: "/portfolio/:id",
      },
      () => import("../pages/ajohomeDashboard/Gallery/Details"),
    ),

    // LazyRoute(
    //   {
    //     path: "/payout",
    //   },
    //   () => import("../pages/ajohomeDashboard/Payout")
    // ),
    LazyRoute(
      {
        path: "/help",
      },
      () => import("../pages/ajohomeDashboard/HelpDesk"),
    ),
    LazyRoute(
      {
        path: "/referral",
      },
      () => import("../pages/ajohomeDashboard/Referral/Referral"),
    ),
    LazyRoute(
      {
        path: "/account",
      },
      () => import("../pages/ajohomeDashboard/Account/Account"),
    ),
    LazyRoute(
      {
        path: "/notification",
      },
      () => import("../pages/ajohomeDashboard/Notifications"),
    ),
    {
      path: "*",
      element: <Navigate to="/dashboard" />,
    },
  ],
};

export const AjosquadAdminDashRouter: IModuleRouter = {
  key: "admindashboard",
  guard: (loggedIn) => loggedIn,
  layout: DashboardLayout,
  routes: [
    {
      index: true,
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "/",
      element: <Navigate to="/dashboard" />,
    },
    LazyRoute(
      {
        path: "/dashboard",
      },
      () => import("../pages/Admin/Dashboard"),
    ),
    LazyRoute(
      {
        path: "/pod",
      },
      () => import("../pages/Admin/pods/index"),
    ),
    LazyRoute(
      {
        path: "/pod/pods",
      },
      () => import("../pages/Admin/pods/pods/index"),
    ),
    LazyRoute(
      {
        path: "/pod/active-pod",
      },
      () => import("../pages/Admin/pods/activePod/ActivePod"),
    ),
    LazyRoute(
      {
        path: "/pod/active-pod/:id",
      },
      () => import("../pages/Admin/pods/activePod/ActivePodDetails"),
    ),
    LazyRoute(
      {
        path: "/pod/ongoing-pod",
      },
      () => import("../pages/Admin/pods/ongoingPod/OngoingPod"),
    ),
    LazyRoute(
      {
        path: "/pod/ongoing-pod/:id",
      },
      () => import("../pages/Admin/pods/ongoingPod/OngoingPodDetails"),
    ),
    LazyRoute(
      {
        path: "/pod/pending-pod",
      },
      () => import("../pages/Admin/pods/pendingPods/pendingPod"),
    ),
    LazyRoute(
      {
        path: "/pod/pending-pod/:id",
      },
      () => import("../pages/Admin/pods/pendingPods/pendingPodDetails"),
    ),
    LazyRoute(
      {
        path: "/pod/completed-pod",
      },
      () => import("../pages/Admin/pods/completedPod/index"),
    ),
    LazyRoute(
      {
        path: "/pod/completed-pod/:id",
      },
      () =>
        import("../pages/Admin/pods/completedPod/CompletedPodMembersDetails"),
    ),
    LazyRoute(
      {
        path: "/pod/members",
      },
      () => import("../pages/Admin/pods/podMembers/index"),
    ),
    LazyRoute(
      {
        path: "/pod/members/:id",
      },
      () => import("../pages/Admin/pods/podMembers/MembersDetails"),
    ),
    LazyRoute(
      {
        path: "/squad",
      },
      () => import("../pages/Admin/squad/Index"),
    ),
    LazyRoute(
      {
        path: "/squad/squad-member",
      },
      () => import("../pages/Admin/squad/SquadMember"),
    ),
    LazyRoute(
      {
        path: "/squad/squad-member/:id",
      },
      () => import("../pages/Admin/squad/SquadMemberDetails"),
    ),
    LazyRoute(
      {
        path: "/squad/completed-squad",
      },
      () => import("../pages/Admin/squad/CompletedSquad"),
    ),
    LazyRoute(
      {
        path: "/squad/completed-squad/:id",
      },
      () => import("../pages/Admin/squad/CompleteSquadDetails"),
    ),
    LazyRoute(
      {
        path: "/squad/active-squad",
      },
      () => import("../pages/Admin/squad/ActiveSquad"),
    ),
    LazyRoute(
      {
        path: "/squad/active-squad/:id",
      },
      () => import("../pages/Admin/squad/ActiveSquadDetails"),
    ),
    LazyRoute(
      {
        path: "/squad/upcoming-squad",
      },
      () => import("../pages/Admin/squad/UpcomingSquad"),
    ),
    LazyRoute(
      {
        path: "/squad/upcoming-squad/:id",
      },
      () => import("../pages/Admin/squad/UpcomingSquadDetails"),
    ),
    LazyRoute(
      {
        path: "/squad/pending-squad",
      },
      () => import("../pages/Admin/squad/PendingSquad"),
    ),
    LazyRoute(
      {
        path: "/squad/pending-squad/:id",
      },
      () => import("../pages/Admin/squad/PendingSquadDetails"),
    ),
    LazyRoute(
      {
        path: "/staff-management",
      },
      () => import("../pages/Admin/StaffManagement"),
    ),
    LazyRoute(
      {
        path: "/member-management",
      },
      () => import("../pages/Admin/member/Index"),
    ),
    LazyRoute(
      {
        path: "/member-management/member-information/:id",
      },
      () => import("../pages/Admin/member/MemberDetails"),
    ),
    LazyRoute(
      {
        path: "/member-management/inactive-member",
      },
      () => import("../pages/Admin/member/InactiveMember"),
    ),
    LazyRoute(
      {
        path: "/member-management/ajosquad-member",
      },
      () => import("../pages/Admin/member/AjosquadMember"),
    ),
    LazyRoute(
      {
        path: "/member-management/ajohome-member",
      },
      () => import("../pages/Admin/member/AjohomeMember"),
    ),
    LazyRoute(
      {
        path: "/payment",
      },
      () => import("../pages/Admin/Payment"),
    ),
    LazyRoute(
      {
        path: "/payout",
      },
      () => import("../pages/Admin/Payout"),
    ),
    LazyRoute(
      {
        path: "/portfolio",
      },
      () => import("../pages/Admin/Gallery/Index"),
    ),
    LazyRoute(
      {
        path: "/portfolio/:id",
      },
      () => import("../pages/ajohomeDashboard/Gallery/Details"),
    ),

    LazyRoute(
      {
        path: "/referral",
      },
      () => import("../pages/Admin/Referral/Referral"),
    ),
    LazyRoute(
      {
        path: "/kyc",
      },
      () => import("../pages/Admin/KycPage"),
    ),
    LazyRoute(
      {
        path: "/guarantor-verification",
      },
      () => import("../pages/Admin/GuarantorVerification"),
    ),
    LazyRoute(
      {
        path: "/payout-info",
      },
      () => import("../pages/Admin/PayoutInfo"),
    ),
    LazyRoute(
      {
        path: "/account",
      },
      () => import("../pages/Admin/Account/Account"),
    ),
    LazyRoute(
      {
        path: "/activity",
      },
      () => import("../pages/Admin/AccountActivity"),
    ),
    LazyRoute(
      {
        path: "/notification",
      },
      () => import("../pages/dashboard/Notifications"),
    ),
    {
      path: "*",
      element: <Navigate to="/dashboard" />,
    },
  ],
};
